// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PAGE BASE */
.partner-page {
  width: 100%;
  background: #425151;
  color: white;
  font-family: "Inter", sans-serif;
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* HEADER */
.partner-header {
  text-align: center;
  padding: 50px 20px 10px;
}

.partner-header h1 {
  font-size: clamp(1.6rem, 3vw, 2.3rem);
  color: #FFE600;
  font-weight: 500;
}

.partner-header p {
  font-size: clamp(0.9rem, 1.4vw, 1.05rem);
  margin-top: 5px;
  color: #e8e8e8;
}

/* INTRO */
.intro-section {
  max-width: 1100px;
  margin: 0 auto 15px;
  padding: 0 10px;
  text-align: center;
  font-size: clamp(1.25rem, 1.2vw, 1.05rem);
  line-height: 1.3;
  color: #FFE600;
  margin-top: 90px;
}

/* WHAT WE PROVIDE */
.provide-section {
  padding: 0px 20px;
  text-align: center;
  margin-top: -10px;
  margin-bottom: 30px;
}

.provide-section h2 {
  font-size: clamp(1.5rem, 2.4vw, 1.9rem);
  color: #FFE600;
  margin-bottom: 15px;
}

/* FORCE 4 CARDS IN 1 ROW */
/* ================================
   RESPONSIVE PROVIDE GRID (AUTO-FIT)
================================ */
.provide-grid {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  display: grid;
  /* THE MAGIC: auto-fit + minmax(auto, 1fr) */
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  padding: 10px 20px;
  box-sizing: border-box;
}

/* CARD — Auto height based on content */
.provide-card {
  background: #ffffff;
  color: #425151;
  border-radius: 14px;
  padding: 22px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  /* AUTO HEIGHT */
  height: auto;
  /* Prevent content overflow */
  box-sizing: border-box;
  margin-bottom: 10px;
  transition: 0.25s ease;
  box-shadow: 0 2px 12px rgba(0,0,0,0.12);
}

.provide-card:hover {
  transform: translateY(-5px);
}

.pi-icon {
  width: 65px;
  height: 65px;
  object-fit: contain;
}

.provide-card h3 {
  margin-top: 12px;
  font-size: clamp(1rem, 1.2vw, 1.2rem);
  font-weight: 600;
}

.provide-card p {
  margin-top: 6px;
  font-size: clamp(0.8rem, 1vw, 1rem);
  line-height: 1.45;
  word-wrap: break-word;
  width: 100%;
}

/* MOBILE */
@media (max-width: 600px) {
  .provide-grid {
    grid-template-columns: 1fr;
  }
  .provide-card {
    padding: 18px;
  }
  .pi-icon {
    width: 58px;
    height: 58px;
  }
  /* .ob-section{
    margin-top: 10px !important;
    row-gap: 10px !important;
    column-gap: 10px !important;
  } */
}

/* LARGE DESKTOPS */
@media (min-width: 1600px) {
  .provide-grid {
    max-width: 1700px;
    gap: 28px;
  }
}

/* INFO CARDS (CORRECTED FULLY) */
.info-section {
  max-width: 1000px;
  margin: 30px auto;
  padding: 0 20px;
  margin-top: 5px;
  margin-bottom: 50px;
}

.info-card {
  background: #ffffff15;
  border-radius: 14px;
  padding: 14px 28px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  border-left: 6px solid #FFE600;
  backdrop-filter: blur(4px);
  transition: 0.3s ease;
  max-width: 1200px;
  height: auto !important;      /* FIXED */
  min-height: 45px;             /* keep shape */
  flex-wrap: wrap;              /* allows long text */
}

.info-card:hover {
  transform: translateY(-4px);
  background: #ffffff25;
}

.info-details h3 {
  flex: 1 1;
  color: #FFE600;
  font-size: clamp(1.0rem, 1.7vw, 1.2rem);
  margin-bottom: 0px;
}

.info-details p {
  color: #e5e5e5;
  font-size: clamp(0.9rem, 1.1vw, 1rem);
  line-height: 1.05;
  margin: 0 !important;
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word;
}

.info-img {
  width: clamp(60px, 7vw, 80px);
  height: clamp(60px, 7vw, 80px);
  object-fit: contain;
}

/* MOBILE INFO CARD FIX */
@media (max-width: 600px) {
  .info-card {
    padding: 12px 18px !important;
    margin-bottom: 16px !important;
  }
  .info-details p {
    font-size: 0.9rem !important;
    line-height: 1.35 !important;
  }
}

/* Mobile stacking */
@media (max-width: 768px) {
  .info-card {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
}

/* OBLIGATIONS */
/* ===== OPTION A: TRUE 2×2 GRID, ZOOM SAFE ===== */
.ob-section {
  width: 100%;
  max-width: 1400px;
  margin: 30px auto 0;
  padding: 20px 20px;
  row-gap: 10px !important;
  column-gap: 20px !important;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 26px;
}

.ob-title {
  text-align: center;
  font-size: clamp(1.5rem, 2.4vw, 2rem);
  color: #FFE600;
  margin-bottom: 0px;
}

/* EACH OBLIGATION CARD */
.ob-row {
  max-width: 900px;
  margin: 0;
  display: grid;
  grid-template-columns: minmax(0, 230px) minmax(0, 1fr);
  align-items: center;
  position: relative;
  height: auto !important;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 22px;
  backdrop-filter: blur(6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);
  padding: 18px 22px;
  gap: 18px;
}

.ob-img {
  width: 100%;
  height: 100%;
  max-height: 160px;
  object-fit: cover;
  border-radius: 18px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.35);
  z-index: 1;
}

.ob-row::before {
  /* removed glass overlay, using card background directly */
  content: none;
}

.ob-content {
  width: 100%;
  z-index: 1;
}

.ob-content h3 {
  color: #FFE600;
  font-size: clamp(1.2rem, 2vw, 1.4rem);
  margin-bottom: 6px;
}

.ob-content p {
  color: #f3f3f3;
  line-height: 1.6;
  font-size: clamp(0.85rem, 1.3vw, 1rem);
  margin: 0;
}

.ob-reverse {
  /* no direction flip needed with grid, kept for compatibility */
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .provide-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .ob-section {
    max-width: 900px;
    grid-template-columns: 1fr;
    gap: 22px;
  }
  .ob-row {
    grid-template-columns: minmax(0, 200px) minmax(0, 1fr);
    padding: 16px 18px;
  }
  .ob-img {
    max-height: 130px;
  }
}

/* Tablet + small desktop tweaks */
@media (max-width: 768px) {
  .ob-row {
    grid-template-columns: 1fr;
    gap: 10px !important;
    text-align: left !important;
  }
  .ob-img {
    width: 100%;
    height: 140px;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.25);
  }
  .ob-content {
    margin-left: 0;
    width: 100% !important;
    margin-top: 0 !important;
  }
  .ob-content h3 {
    margin-bottom: 6px !important;
  }
}

/* Extra mobile tweaks */
@media (max-width: 600px) {
  .partner-header {
    padding: 40px 10px 10px;
  }
  .partner-header h1 {
    font-size: 1.5rem;
  }
  .partner-header p {
    font-size: 0.9rem;
  }
  .intro-section {
    font-size: 1rem;
    line-height: 1.45;
    margin-top: 125px;
  }
}

/* CONTACT */
.contact1-section {
  text-align: center;
  padding: 10px 20px;
}

.contact1-section h2 {
  color: #FFE600;
  font-size: clamp(1.4rem, 2.5vw, 2rem);
}

.contact1-box {
  margin: 25px auto;
  background: white;
  color: #425151;
  padding: 20px;
  border-radius: 12px;
  width: min(420px, 90%);
  box-shadow: 0 3px 12px rgba(0,0,0,0.15);
}

.contact1-btn {
  margin-top: 10px;
  padding: 14px 36px;
  background: #FFE600;
  color: #425151;
  border-radius: 10px;
  font-size: clamp(1rem, 1.7vw, 1.1rem);
  border: none;
  cursor: pointer;
  transition: 0.3s;
}

.contact1-btn:hover {
  background: #ffef77;
  transform: translateY(-3px);
}

@media (max-width: 768px) {
  .info-card {
    flex-direction: column !important;
    text-align: left !important;
    gap: 10px !important;
    width: 100% !important;
  }
}

/* ==========================================================
   LARGE DESKTOPS — 1440px & ABOVE
=========================================================== */
@media (min-width: 1440px) {
  .partner-page {
    padding-bottom: 60px;
  }
  .partner-header h1 {
    font-size: 2.8rem;
  }
  .partner-header p {
    font-size: 1.3rem;
  }
  .intro-section {
    font-size: 1.45rem;
    max-width: 1200px;
  }
  /* 4 cards wider spacing */
  .provide-grid {
    max-width: 1400px;
    gap: 18px;
  }
  .provide-card {
    padding: 24px;
    min-height: 150px;
  }
  .provide-card h3 {
    font-size: 1.25rem;
  }
  .provide-card p {
    font-size: 1rem;
  }
  .pi-icon {
    width: 72px;
    height: 72px;
  }
  /* Info rows */
  .info-section {
    max-width: 1300px;
  }
  .info-card {
    padding: 20px 40px;
    min-height: 70px;
  }
  .info-details h3 {
    font-size: 1.6rem;
  }
  .info-details p {
    font-size: 1.2rem;
    line-height: 1.35;
  }
  .info-img {
    width: 110px;
    height: 110px;
  }
  /* Obligations rows */
  .ob-section {
    max-width: 1600px;
    margin: 0 auto;
    gap: 40px;
  }
  .ob-row {
    padding: 20px 30px;
  }
  .ob-img {
    max-height: 200px;
  }
  .ob-content h3 {
    font-size: 1.8rem;
  }
  .ob-content p {
    font-size: 1.2rem;
    line-height: 1.55;
  }
  /* Contact */
  .contact1-section h2 {
    font-size: 2.4rem;
  }
  .contact1-box {
    width: min(520px, 90%);
  }
  .contact1-btn {
    font-size: 1.3rem;
    padding: 16px 42px;
  }
}

/* ==========================================================
   ULTRA-WIDE DESKTOPS — 1920px / 2K
=========================================================== */
@media (min-width: 1920px) {
  .partner-header h1 {
    font-size: 3.2rem;
  }
  .intro-section {
    font-size: 1.6rem;
    max-width: 1500px;
  }
  .provide-grid {
    max-width: 1700px;
    gap: 26px;
  }
  .provide-card {
    padding: 30px;
    min-height: 180px;
  }
  .provide-card h3 {
    font-size: 1.35rem;
  }
  .provide-card p {
    font-size: 1.1rem;
  }
  .pi-icon {
    width: 90px;
    height: 90px;
  }
  .info-section {
    max-width: 1600px;
  }
  .info-card {
    padding: 30px 50px;
  }
  .info-details h3 {
    font-size: 1.9rem;
  }
  .info-details p {
    font-size: 1.35rem;
  }
  .info-img {
    width: 130px;
    height: 130px;
  }
  .ob-section {
    gap: 60px;
  }
  .ob-row {
    gap: 24px;
  }
  .ob-img {
    max-height: 240px;
  }
  .ob-content h3 {
    font-size: 2rem;
  }
  .ob-content p {
    font-size: 1.35rem;
  }
  .contact1-section h2 {
    font-size: 2.7rem;
  }
  .contact1-btn {
    font-size: 1.4rem;
  }
}

/* ==========================================================
   4K / 2560px — FULL WIDESCREEN MODE
=========================================================== */
@media (min-width: 2560px) {
  .partner-header h1 {
    font-size: 3.8rem;
  }
  .partner-header p {
    font-size: 1.6rem;
  }
  .intro-section {
    font-size: 1.9rem;
    max-width: 1800px;
  }
  .provide-grid {
    max-width: 2100px;
    gap: 40px;
  }
  .provide-card {
    padding: 38px;
    min-height: 220px;
    border-radius: 18px;
  }
  .provide-card h3 {
    font-size: 1.55rem;
  }
  .provide-card p {
    font-size: 1.25rem;
  }
  .pi-icon {
    width: 110px;
    height: 110px;
  }
  /* Info cards */
  .info-card {
    padding: 40px 60px;
  }
  .info-details h3 {
    font-size: 2.3rem;
  }
  .info-details p {
    font-size: 1.55rem;
    line-height: 1.6;
  }
  .info-img {
    width: 160px;
    height: 160px;
  }
  /* Obligations */
  .ob-row {
    gap: 30px;
  }
  .ob-img {
    max-height: 280px;
  }
  .ob-content h3 {
    font-size: 2.3rem;
  }
  .ob-content p {
    font-size: 1.5rem;
  }
  .contact1-section h2 {
    font-size: 3.2rem;
  }
  .contact1-btn {
    font-size: 1.6rem;
    padding: 20px 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/PARTNERWITHUS/partner.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;kCAEkC;AAClC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,4CAA4C;EAC5C,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;;;;KAIG;AACL;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB,OAAO,UAAU;EACxC,gBAAgB,cAAc,eAAe;EAC7C,eAAe,eAAe,qBAAqB;AACrD;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA,gBAAgB;AAChB,mDAAmD;AACnD;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,0DAA0D;EAC1D,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,+DAA+D;AACjE;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,sDAAsD;IACtD,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,iCAAiC;IACjC,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;EACxB;AACF;;AAEA;;6DAE6D;AAC7D;EACE;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA,0BAA0B;EAC1B;IACE,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,cAAc;EACd;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA,qBAAqB;EACrB;IACE,iBAAiB;IACjB,cAAc;IACd,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA,YAAY;EACZ;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;6DAE6D;AAC7D;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;;6DAE6D;AAC7D;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA,eAAe;EACf;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA,gBAAgB;EAChB;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":["/* PAGE BASE */\n.partner-page {\n  width: 100%;\n  background: #425151;\n  color: white;\n  font-family: \"Inter\", sans-serif;\n  overflow-x: hidden;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n/* HEADER */\n.partner-header {\n  text-align: center;\n  padding: 50px 20px 10px;\n}\n\n.partner-header h1 {\n  font-size: clamp(1.6rem, 3vw, 2.3rem);\n  color: #FFE600;\n  font-weight: 500;\n}\n\n.partner-header p {\n  font-size: clamp(0.9rem, 1.4vw, 1.05rem);\n  margin-top: 5px;\n  color: #e8e8e8;\n}\n\n/* INTRO */\n.intro-section {\n  max-width: 1100px;\n  margin: 0 auto 15px;\n  padding: 0 10px;\n  text-align: center;\n  font-size: clamp(1.25rem, 1.2vw, 1.05rem);\n  line-height: 1.3;\n  color: #FFE600;\n  margin-top: 90px;\n}\n\n/* WHAT WE PROVIDE */\n.provide-section {\n  padding: 0px 20px;\n  text-align: center;\n  margin-top: -10px;\n  margin-bottom: 30px;\n}\n\n.provide-section h2 {\n  font-size: clamp(1.5rem, 2.4vw, 1.9rem);\n  color: #FFE600;\n  margin-bottom: 15px;\n}\n\n/* FORCE 4 CARDS IN 1 ROW */\n/* ================================\n   RESPONSIVE PROVIDE GRID (AUTO-FIT)\n================================ */\n.provide-grid {\n  width: 100%;\n  max-width: 1500px;\n  margin: 0 auto;\n  display: grid;\n  /* THE MAGIC: auto-fit + minmax(auto, 1fr) */\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 24px;\n  padding: 10px 20px;\n  box-sizing: border-box;\n}\n\n/* CARD — Auto height based on content */\n.provide-card {\n  background: #ffffff;\n  color: #425151;\n  border-radius: 14px;\n  padding: 22px;\n  border: 1px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  /* AUTO HEIGHT */\n  height: auto;\n  /* Prevent content overflow */\n  box-sizing: border-box;\n  margin-bottom: 10px;\n  transition: 0.25s ease;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.12);\n}\n\n.provide-card:hover {\n  transform: translateY(-5px);\n}\n\n.pi-icon {\n  width: 65px;\n  height: 65px;\n  object-fit: contain;\n}\n\n.provide-card h3 {\n  margin-top: 12px;\n  font-size: clamp(1rem, 1.2vw, 1.2rem);\n  font-weight: 600;\n}\n\n.provide-card p {\n  margin-top: 6px;\n  font-size: clamp(0.8rem, 1vw, 1rem);\n  line-height: 1.45;\n  word-wrap: break-word;\n  width: 100%;\n}\n\n/* MOBILE */\n@media (max-width: 600px) {\n  .provide-grid {\n    grid-template-columns: 1fr;\n  }\n  .provide-card {\n    padding: 18px;\n  }\n  .pi-icon {\n    width: 58px;\n    height: 58px;\n  }\n  /* .ob-section{\n    margin-top: 10px !important;\n    row-gap: 10px !important;\n    column-gap: 10px !important;\n  } */\n}\n\n/* LARGE DESKTOPS */\n@media (min-width: 1600px) {\n  .provide-grid {\n    max-width: 1700px;\n    gap: 28px;\n  }\n}\n\n/* INFO CARDS (CORRECTED FULLY) */\n.info-section {\n  max-width: 1000px;\n  margin: 30px auto;\n  padding: 0 20px;\n  margin-top: 5px;\n  margin-bottom: 50px;\n}\n\n.info-card {\n  background: #ffffff15;\n  border-radius: 14px;\n  padding: 14px 28px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  border-left: 6px solid #FFE600;\n  backdrop-filter: blur(4px);\n  transition: 0.3s ease;\n  max-width: 1200px;\n  height: auto !important;      /* FIXED */\n  min-height: 45px;             /* keep shape */\n  flex-wrap: wrap;              /* allows long text */\n}\n\n.info-card:hover {\n  transform: translateY(-4px);\n  background: #ffffff25;\n}\n\n.info-details h3 {\n  flex: 1;\n  color: #FFE600;\n  font-size: clamp(1.0rem, 1.7vw, 1.2rem);\n  margin-bottom: 0px;\n}\n\n.info-details p {\n  color: #e5e5e5;\n  font-size: clamp(0.9rem, 1.1vw, 1rem);\n  line-height: 1.05;\n  margin: 0 !important;\n  white-space: normal !important;\n  word-break: break-word !important;\n  overflow-wrap: break-word;\n}\n\n.info-img {\n  width: clamp(60px, 7vw, 80px);\n  height: clamp(60px, 7vw, 80px);\n  object-fit: contain;\n}\n\n/* MOBILE INFO CARD FIX */\n@media (max-width: 600px) {\n  .info-card {\n    padding: 12px 18px !important;\n    margin-bottom: 16px !important;\n  }\n  .info-details p {\n    font-size: 0.9rem !important;\n    line-height: 1.35 !important;\n  }\n}\n\n/* Mobile stacking */\n@media (max-width: 768px) {\n  .info-card {\n    flex-direction: column;\n    text-align: center;\n    gap: 15px;\n  }\n}\n\n/* OBLIGATIONS */\n/* ===== OPTION A: TRUE 2×2 GRID, ZOOM SAFE ===== */\n.ob-section {\n  width: 100%;\n  max-width: 1400px;\n  margin: 30px auto 0;\n  padding: 20px 20px;\n  row-gap: 10px !important;\n  column-gap: 20px !important;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 26px;\n}\n\n.ob-title {\n  text-align: center;\n  font-size: clamp(1.5rem, 2.4vw, 2rem);\n  color: #FFE600;\n  margin-bottom: 0px;\n}\n\n/* EACH OBLIGATION CARD */\n.ob-row {\n  max-width: 900px;\n  margin: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 230px) minmax(0, 1fr);\n  align-items: center;\n  position: relative;\n  height: auto !important;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 22px;\n  backdrop-filter: blur(6px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.35);\n  padding: 18px 22px;\n  gap: 18px;\n}\n\n.ob-img {\n  width: 100%;\n  height: 100%;\n  max-height: 160px;\n  object-fit: cover;\n  border-radius: 18px;\n  box-shadow: 0 10px 25px rgba(0,0,0,0.35);\n  z-index: 1;\n}\n\n.ob-row::before {\n  /* removed glass overlay, using card background directly */\n  content: none;\n}\n\n.ob-content {\n  width: 100%;\n  z-index: 1;\n}\n\n.ob-content h3 {\n  color: #FFE600;\n  font-size: clamp(1.2rem, 2vw, 1.4rem);\n  margin-bottom: 6px;\n}\n\n.ob-content p {\n  color: #f3f3f3;\n  line-height: 1.6;\n  font-size: clamp(0.85rem, 1.3vw, 1rem);\n  margin: 0;\n}\n\n.ob-reverse {\n  /* no direction flip needed with grid, kept for compatibility */\n}\n\n/* RESPONSIVE */\n@media (max-width: 992px) {\n  .provide-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .ob-section {\n    max-width: 900px;\n    grid-template-columns: 1fr;\n    gap: 22px;\n  }\n  .ob-row {\n    grid-template-columns: minmax(0, 200px) minmax(0, 1fr);\n    padding: 16px 18px;\n  }\n  .ob-img {\n    max-height: 130px;\n  }\n}\n\n/* Tablet + small desktop tweaks */\n@media (max-width: 768px) {\n  .ob-row {\n    grid-template-columns: 1fr;\n    gap: 10px !important;\n    text-align: left !important;\n  }\n  .ob-img {\n    width: 100%;\n    height: 140px;\n    border-radius: 14px;\n    box-shadow: 0 6px 20px rgba(0,0,0,0.25);\n  }\n  .ob-content {\n    margin-left: 0;\n    width: 100% !important;\n    margin-top: 0 !important;\n  }\n  .ob-content h3 {\n    margin-bottom: 6px !important;\n  }\n}\n\n/* Extra mobile tweaks */\n@media (max-width: 600px) {\n  .partner-header {\n    padding: 40px 10px 10px;\n  }\n  .partner-header h1 {\n    font-size: 1.5rem;\n  }\n  .partner-header p {\n    font-size: 0.9rem;\n  }\n  .intro-section {\n    font-size: 1rem;\n    line-height: 1.45;\n    margin-top: 125px;\n  }\n}\n\n/* CONTACT */\n.contact1-section {\n  text-align: center;\n  padding: 10px 20px;\n}\n\n.contact1-section h2 {\n  color: #FFE600;\n  font-size: clamp(1.4rem, 2.5vw, 2rem);\n}\n\n.contact1-box {\n  margin: 25px auto;\n  background: white;\n  color: #425151;\n  padding: 20px;\n  border-radius: 12px;\n  width: min(420px, 90%);\n  box-shadow: 0 3px 12px rgba(0,0,0,0.15);\n}\n\n.contact1-btn {\n  margin-top: 10px;\n  padding: 14px 36px;\n  background: #FFE600;\n  color: #425151;\n  border-radius: 10px;\n  font-size: clamp(1rem, 1.7vw, 1.1rem);\n  border: none;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.contact1-btn:hover {\n  background: #ffef77;\n  transform: translateY(-3px);\n}\n\n@media (max-width: 768px) {\n  .info-card {\n    flex-direction: column !important;\n    text-align: left !important;\n    gap: 10px !important;\n    width: 100% !important;\n  }\n}\n\n/* ==========================================================\n   LARGE DESKTOPS — 1440px & ABOVE\n=========================================================== */\n@media (min-width: 1440px) {\n  .partner-page {\n    padding-bottom: 60px;\n  }\n  .partner-header h1 {\n    font-size: 2.8rem;\n  }\n  .partner-header p {\n    font-size: 1.3rem;\n  }\n  .intro-section {\n    font-size: 1.45rem;\n    max-width: 1200px;\n  }\n  /* 4 cards wider spacing */\n  .provide-grid {\n    max-width: 1400px;\n    gap: 18px;\n  }\n  .provide-card {\n    padding: 24px;\n    min-height: 150px;\n  }\n  .provide-card h3 {\n    font-size: 1.25rem;\n  }\n  .provide-card p {\n    font-size: 1rem;\n  }\n  .pi-icon {\n    width: 72px;\n    height: 72px;\n  }\n  /* Info rows */\n  .info-section {\n    max-width: 1300px;\n  }\n  .info-card {\n    padding: 20px 40px;\n    min-height: 70px;\n  }\n  .info-details h3 {\n    font-size: 1.6rem;\n  }\n  .info-details p {\n    font-size: 1.2rem;\n    line-height: 1.35;\n  }\n  .info-img {\n    width: 110px;\n    height: 110px;\n  }\n  /* Obligations rows */\n  .ob-section {\n    max-width: 1600px;\n    margin: 0 auto;\n    gap: 40px;\n  }\n  .ob-row {\n    padding: 20px 30px;\n  }\n  .ob-img {\n    max-height: 200px;\n  }\n  .ob-content h3 {\n    font-size: 1.8rem;\n  }\n  .ob-content p {\n    font-size: 1.2rem;\n    line-height: 1.55;\n  }\n  /* Contact */\n  .contact1-section h2 {\n    font-size: 2.4rem;\n  }\n  .contact1-box {\n    width: min(520px, 90%);\n  }\n  .contact1-btn {\n    font-size: 1.3rem;\n    padding: 16px 42px;\n  }\n}\n\n/* ==========================================================\n   ULTRA-WIDE DESKTOPS — 1920px / 2K\n=========================================================== */\n@media (min-width: 1920px) {\n  .partner-header h1 {\n    font-size: 3.2rem;\n  }\n  .intro-section {\n    font-size: 1.6rem;\n    max-width: 1500px;\n  }\n  .provide-grid {\n    max-width: 1700px;\n    gap: 26px;\n  }\n  .provide-card {\n    padding: 30px;\n    min-height: 180px;\n  }\n  .provide-card h3 {\n    font-size: 1.35rem;\n  }\n  .provide-card p {\n    font-size: 1.1rem;\n  }\n  .pi-icon {\n    width: 90px;\n    height: 90px;\n  }\n  .info-section {\n    max-width: 1600px;\n  }\n  .info-card {\n    padding: 30px 50px;\n  }\n  .info-details h3 {\n    font-size: 1.9rem;\n  }\n  .info-details p {\n    font-size: 1.35rem;\n  }\n  .info-img {\n    width: 130px;\n    height: 130px;\n  }\n  .ob-section {\n    gap: 60px;\n  }\n  .ob-row {\n    gap: 24px;\n  }\n  .ob-img {\n    max-height: 240px;\n  }\n  .ob-content h3 {\n    font-size: 2rem;\n  }\n  .ob-content p {\n    font-size: 1.35rem;\n  }\n  .contact1-section h2 {\n    font-size: 2.7rem;\n  }\n  .contact1-btn {\n    font-size: 1.4rem;\n  }\n}\n\n/* ==========================================================\n   4K / 2560px — FULL WIDESCREEN MODE\n=========================================================== */\n@media (min-width: 2560px) {\n  .partner-header h1 {\n    font-size: 3.8rem;\n  }\n  .partner-header p {\n    font-size: 1.6rem;\n  }\n  .intro-section {\n    font-size: 1.9rem;\n    max-width: 1800px;\n  }\n  .provide-grid {\n    max-width: 2100px;\n    gap: 40px;\n  }\n  .provide-card {\n    padding: 38px;\n    min-height: 220px;\n    border-radius: 18px;\n  }\n  .provide-card h3 {\n    font-size: 1.55rem;\n  }\n  .provide-card p {\n    font-size: 1.25rem;\n  }\n  .pi-icon {\n    width: 110px;\n    height: 110px;\n  }\n  /* Info cards */\n  .info-card {\n    padding: 40px 60px;\n  }\n  .info-details h3 {\n    font-size: 2.3rem;\n  }\n  .info-details p {\n    font-size: 1.55rem;\n    line-height: 1.6;\n  }\n  .info-img {\n    width: 160px;\n    height: 160px;\n  }\n  /* Obligations */\n  .ob-row {\n    gap: 30px;\n  }\n  .ob-img {\n    max-height: 280px;\n  }\n  .ob-content h3 {\n    font-size: 2.3rem;\n  }\n  .ob-content p {\n    font-size: 1.5rem;\n  }\n  .contact1-section h2 {\n    font-size: 3.2rem;\n  }\n  .contact1-btn {\n    font-size: 1.6rem;\n    padding: 20px 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
